import {RichText} from '@gongxigames/framework/core/fragments/display';

RichText.setStyle('elapsedTimeClock', {
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 50,
    fontWeight: 'bold',
    align: 'center',
    fill: '0xd1d1d1'
});
RichText.setStyle('netPositionBalanceDesktop', {
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 50,
    fontWeight: 'bold',
    align: 'left',
    fill: '0xd1d1d1'
});
RichText.setStyle('netPositionBalanceLandscape', {
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 50,
    fontWeight: 'bold',
    align: 'right',
    fill: '0xd1d1d1'
});
RichText.setStyle('netPositionBalancePortrait', {
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 50,
    fontWeight: 'bold',
    align: 'center',
    fill: '0xd1d1d1'
});
